import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TAGS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('TAGS');
export const TAGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(TAGS_CRUD_ACTION_CONSTANTS);
